import NowakApi from './NowakApi'
import store from '@/store/index.js'
var Api = new NowakApi({
  url: store.getters.liveServerUrl
})

export default Api



// WEBPACK FOOTER //
// ./src/api/API.js